

interface IContacto {
    id: number
    nombre: string
    correo: string
    telefono: string
    nombreClienteDistribuidorContacto?: string
    clienteDistribuidorID?: number
}

export class Contacto {
    constructor(props: IContacto) {
        Object.assign(this, props);
    }
}

export interface Contacto extends IContacto {
}
